/** Boots the React application and imports the single global design-system stylesheet. */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { registerPwa } from './app/registerPwa';
import './app/styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('The application root element is missing.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerPwa();
